export default __webpack_public_path__ + "static/media/mobile-menu-decoration.c7e9d974.svg";